import { useEffect, useState } from "react";

import { getCurrentUserOwnerCandidates } from "../utils/ownerScope";

/** Every format the current user's id can take in a stored `owner` (sub, username, sub::username). */
export function useOwnerCandidates(): string[] {
  const [candidates, setCandidates] = useState<string[]>([]);
  useEffect(() => {
    let cancelled = false;
    getCurrentUserOwnerCandidates().then((result) => {
      if (!cancelled) setCandidates(result);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return candidates;
}
